import { Component, OnInit } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { UnitsProvider } from "../../shared/providers/units.provider";
import { AdminDataProvider } from '../../shared/providers/master-provider/admin-data.provider';
import { UnitsModel } from "../../shared/models/units";
import { ToastClientService } from "src/app/services/toast/toast-client.service";

@Component({
  selector: 'app-units',
  templateUrl: './units.component.html',
  styleUrls: ['./units.component.scss']
})
export class UnitsComponent implements OnInit {

  addOrEditUnit: String;
  units: UnitsModel[] = [];
  title = "modal2";
  formGroup;
  deletePopupUiData;


  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    public unitsProviders: UnitsProvider,
    public adminDataProvider: AdminDataProvider,
    private toast: ToastClientService,
  ) { }
  shelve_details = {
    Shelf_1: {
      Horlicks: 0.0,
      Kurkure: 16.67,
      Nivea_blue: 0.0,
      Nivea_lightblue: 0.0,
      Nivea_white: 0.0,
      Other_brands: 83.33
    },
    Shelf_2: {
      Horlicks: 0.0,
      Kurkure: 77.78,
      Nivea_blue: 0.0,
      Nivea_lightblue: 0.0,
      Nivea_white: 0.0,
      Other_brands: 22.22
    },
    Shelf_3: {
      Horlicks: 0.0,
      Kurkure: 81.82,
      Nivea_blue: 0.0,
      Nivea_lightblue: 0.0,
      Nivea_white: 0.0,
      Other_brands: 18.18
    }
  }
  ngOnInit() {
    this.sample();
  }

  ngDoCheck() {
    this.units = this.unitsProviders.units;
    // console.log(this.units);
  }

  addUnit(targetModal) {
    this.addOrEditUnit = "add";
    this.formGroup = this.fb.group({
      program_id: 1,
      unit_name: new FormControl("", [Validators.required]),
      unit_desc: new FormControl("", [Validators.required]),
    });

    this.showUnitModal(targetModal);
  }

  get f() {
    return this.formGroup.controls;
  }

  editUnit(targetModal, unitInfo) {
    console.log(unitInfo);
    this.addOrEditUnit = "edit";
    this.formGroup = this.fb.group({
      id: unitInfo.id,
      unit_name: new FormControl(unitInfo.unit_name, [Validators.required]),
      unit_desc: new FormControl(unitInfo.unit_desc, [Validators.required]),
      program_id: 1,
      status: 1
    });

    this.showUnitModal(targetModal);
  }

  deleteUnit(targetModal, unitInfo) {
    this.addOrEditUnit = "delete";
    this.deletePopupUiData = unitInfo.unit_name;

    this.formGroup = this.fb.group({
      id: unitInfo.id,
      status: 0,
      program_id: 1,
    });

    this.showUnitModal(targetModal);
  }

  showUnitModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  submitted = false;

  onSubmitUnit(formData: UnitsModel) {
    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }


    if (this.addOrEditUnit == "add") {
      this.unitsProviders.unitAdd(formData);
    } else if (this.addOrEditUnit == "edit") {
      this.unitsProviders.unitEdit(formData);
    } else if (this.addOrEditUnit == "delete") {
      this.unitsProviders.unitDelete(formData);
    }
    this.modalService.dismissAll();
  }

  
  sample() {
    let shelveArray = Object.keys(this.shelve_details);
    let formatedDetails  = {
      headers: ['key'],
      body: [],
      keys: shelveArray
    };
    let a = [this.shelve_details];
    for (let value in a[0]) {
      formatedDetails.body.push(a[0][value]);
    }
    for (let value in formatedDetails.body[0]) {
      formatedDetails.headers.push(value);
    }
    formatedDetails.body.forEach((element, i) => {
      element.key = shelveArray[i];
    });
    console.log(formatedDetails);

    //Creation of table
    let append = document.getElementById('testTable')
    var tbl = document.createElement('table');
    tbl.style.width = '100%';
    tbl.setAttribute('border', '1');
    var thead = document.createElement('thead');
    tbl.appendChild(thead);
    var trH = document.createElement('tr');
    thead.appendChild(trH);

    for (let i = 0; i < formatedDetails.headers.length; i++) {
      let tdH = document.createElement('th');


      if(formatedDetails.headers[i] === 'key'){
        tdH.innerHTML += 'No.'
      } else{

        tdH.innerHTML += formatedDetails.headers[i]
      }

      trH.appendChild(tdH);
    }
    var tbdy = document.createElement('tbody');

    for (let b1 = 0; b1 < formatedDetails.body.length; b1++) {
      var trB = document.createElement('tr');
      tbdy.appendChild(trB);
      for (let b2 = 0; b2 < formatedDetails.headers.length; b2++) {
        let tdB = document.createElement('td');
        tdB.innerHTML += formatedDetails.body[b1][formatedDetails.headers[b2]]
        trB.appendChild(tdB)
      }

    }
    tbl.appendChild(tbdy);
    append.appendChild(tbl)
    console.log(tbl);
  }
}
